import React from 'react'
import { CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilHome } from '@coreui/icons'
import { Link } from 'react-router-dom'

const Page404 = () => (
  <div className="d-flex align-items-center justify-content-center vh-100">
    <CCard className="text-center shadow-lg p-4" style={{ maxWidth: '500px' }}>
      <CCardHeader className="bg-danger text-white fs-4 fw-bold">Oops! Page Not Found</CCardHeader>
      <CCardBody className="p-5">
        <div className="display-1 fw-bold text-danger">404</div>
        <p className="lead mt-3 text-muted">
          The page you are looking for does not exist or has been moved.
        </p>
        <p className="text-muted">Please check the URL or return to the homepage.</p>
        <Link
          className="btn btn-danger btn-lg mt-3 d-flex align-items-center justify-content-center"
          to="/"
        >
          <CIcon icon={cilHome} className="me-2" />
          Go Home
        </Link>
      </CCardBody>
    </CCard>
  </div>
)

export default Page404
